export interface User {
  id: number;
  userName?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  emailName?: string;
  roles?: string[];
  email?: string;
  lastLogin?: Date;
}

export enum RoleTypes {
  adminRole = 'Administrators',
}
